<script>
import { mapGetters } from 'vuex';
import { useAdmin } from 'dashboard/composables/useAdmin';

import CommentEditor from './CommentEditor.vue';
import Comments from './Comments.vue';

import Icon from 'dashboard/components-next/icon/Icon.vue';
import TabBar from 'next/tabbar/TabBar.vue';
import AuditTrails from './AuditTrails.vue';

export default {
  components: {
    CommentEditor,
    Comments,
    Icon,
    TabBar,
    AuditTrails,
  },
  props: {
    board: {
      type: Object,
      default: () => {},
    },
    card: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Object,
      default: () => {},
    },
    agents: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { isAdmin } = useAdmin();

    return {
      isAdmin,
    };
  },
  data() {
    return {
      activeTab: 'comments',
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    readonly() {
      return this.board.closed;
    },
    activeTabIndex() {
      return this.tabs.findIndex(tab => tab.value === this.activeTab);
    },
    tabs() {
      const tabs = [
        {
          label: this.$t(
            'WGPT_BOARDS.ITEM.LIST.CARD.EDIT.ACTIVITIES.TABS.COMMENTS'
          ),
          value: 'comments',
        },
      ];
      if (this.isAdmin) {
        tabs.push({
          label: this.$t(
            'WGPT_BOARDS.ITEM.LIST.CARD.EDIT.ACTIVITIES.TABS.HISTORY'
          ),
          value: 'history',
        });
      }
      return tabs;
    },
  },
  methods: {
    async uploadFileToStorage(file) {
      const data = {
        file,
        boardId: this.board.id,
        listId: this.list.id,
        id: this.card.id,
      };
      const fileInfo = await this.$store.dispatch(
        'wgptBoardListCards/addAttachment',
        data
      );
      return fileInfo.file_url;
    },
    handleTabChange(tab) {
      this.activeTab = tab.value;
    },
  },
};
</script>

<template>
  <div>
    <div class="flex gap-6">
      <Icon icon="i-lucide-list" class="mt-1 w-5 h-5 text-slate-500" />
      <div class="flex-1 w-full">
        <label>
          {{ $t('WGPT_BOARDS.ITEM.LIST.CARD.EDIT.FORM.ACTIVITY.LABEL') }}
        </label>

        <TabBar
          v-if="tabs.length > 1"
          :tabs="tabs"
          :initial-active-tab="activeTabIndex"
          class="!h-6 my-2 -ms-2 [&>button]:w-max [&>button]:px-2 [&>div]:max-h-full bg-n-alpha-black2"
          @tab-changed="handleTabChange"
        />
      </div>
    </div>

    <template v-if="activeTab === 'comments'">
      <CommentEditor
        v-if="!readonly"
        class="mt-4"
        :board="board"
        :card="card"
        :list="list"
        :upload-file="uploadFileToStorage"
        :agents="agents"
      />

      <Comments
        class="mt-5"
        :board="board"
        :card="card"
        :list="list"
        :current-user-id="currentUser.id"
        :available-agents="agents"
        :readonly="readonly"
        :upload-file="uploadFileToStorage"
      />
    </template>

    <AuditTrails v-if="activeTab === 'history'" class="mt-5" :card="card" />
  </div>
</template>
